<!--关联其他吉利邮箱-->
<template>
	<div class="asOtherAccount">
		<el-form ref="form" :model="asAccountInfo" label-width="80px">
			<el-form-item label="关联账号">
				<el-input placeholder="请输入账号" v-model="asAccountInfo.account"></el-input>
			</el-form-item>
			<el-form-item label="密码">
				<el-input placeholder="请输入密码" v-model="asAccountInfo.password"></el-input>
			</el-form-item>
		</el-form>
		<div class="button">
			<div>
				<el-button type="primary" @click="confirmAsFn()">确认关联</el-button>
				<el-button @click="$emit('hideAsAccountDialog')">取消</el-button>
			</div>
		</div>
	</div>
</template> 

<script>
export default {
  props: [],
  data() {
    return {
      asAccountInfo: {
        //关联账号信息
        account: "", //账号
        password: "" //密码
      }
    }
  },
  methods: {
    //确认关联按钮
    confirmAsFn() {
      this.$emit("hideAsAccountDialog")
    }
  }
}
</script>

<style lang="scss" scoped>
.asOtherAccount {
  padding-bottom: 60px;
  /deep/ .el-form-item__label {
    padding-right: 22px;
  }
  .button {
    .el-button {
      width: 100px;
      height: 37px;
    }
    .el-button--default {
      margin-left: 10px;
      border: 1px solid #4d88cc;
    }
    > div {
      float: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/asOtherAccount.vue